import { ReactElement, ReactNode, useCallback, useContext, useEffect, useState } from 'react';
import { ControllerContext } from '../ts/Contexts';
import LazyLoader from './lazyLoader';

export const notifications_page = '/notifications';
export const settings_page = '/settings';
export const owners_page = '/owners';
export const userAudit_page = '/userAudit';
export const locks_page = '/locks';
export const config_page = '/config';
export const votes_page = '/votes';
export const pillory_page = '/pillory';
export const members_page = '/members';
export const sessions_page = '/sessions';
export const home_page = '/home';
export const items_page = '/items';
export const root_page = '/';
export const editProfile_page = '/editProfile';
export const settingsManager_page = '/settingsManager';
export const lovense_page = '/lovense';
export const welcome_page = '/welcome';
export const json_page = '/json';

export const navigateToPage = (target: string, history: (path: string) => void, command?: string, version?: boolean) => {
    let path = command ? `${target}?command=${command}` : target;
    if (version && command) path = `${path}&version=${Date.now()}`;
    else if (version) path = `${path}?version=${Date.now()}`;
    setTimeout(() => {
        history(path)
        window.scrollTo(0, 0);
    }, 0);
};

interface ProtectedPageProps {
    authCheck: () => boolean | undefined;
    children: ReactNode[] | ReactNode;
}

export const ProtectedPage = ({ authCheck, children }: ProtectedPageProps): ReactElement | null => {
    const controller = useContext(ControllerContext);
    const [controlLoaded, setControlLoaded] = useState(false);
    const refreshData = useCallback(() => {
        const settings = controller.getLoggedOnUserSettings();
        setControlLoaded(settings.isControlLoaded());
    }, [controller]);

    useEffect(() => {
        const settings = controller.getLoggedOnUserSettings();
        if (settings.isControlLoaded()) setControlLoaded(true);
        else {
            settings.subscribeToControlRecord(refreshData);
            settings.subscribeToLoaded(refreshData);
            refreshData();
        }
        return () => {
            settings.unsubscribeToControlRecord(refreshData);
            settings.unsubscribeToLoaded(refreshData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!controller || !controlLoaded) return <LazyLoader
        status="Loading Page"
    />;
    let innerChildren = children;
    if (!authCheck()) innerChildren = <div className='logo'><span>Unavailable to role</span></div>;
    return <div>{innerChildren}</div>;
}